<script lang="ts">
  export let onLogout: () => void;
  export let displayName: string | null;
  export let email: string;
</script>

<div class="logout-row">
  <span class="user-id" title={email}>
    {displayName ?? email}
  </span>
  <button class="logout-btn" type="button" on:click={onLogout}>Sair</button>
</div>

<style>
  .logout-row {
    display: flex;
    align-items: center;
    gap: var(--ptt-space-3, 12px);
    font-size: 0.875rem;
  }
  .user-id {
    color: var(--ptt-gray-200, #565656);
  }
  .logout-btn {
    background: transparent;
    border: 1px solid var(--ptt-gray-100, #7D7D7D);
    border-radius: var(--ptt-radius-sm, 4px);
    padding: 4px 12px;
    cursor: pointer;
    color: var(--ptt-gray-300, #323232);
  }
  .logout-btn:hover {
    background: var(--ptt-gray-50, #F2F2F2);
  }
</style>
